import React from 'react';

/**
 * Shared loading spinner. Ring + rotate animation live in index.css
 * (.spinner / @keyframes spin) so no file needs its own keyframes.
 */
export default function Spinner({ size = 40, label }) {
  const border = Math.max(2, Math.round(size / 10));
  return (
    <div role="status" aria-live="polite" style={{ textAlign: 'center', padding: '20px' }}>
      <div
        className="spinner"
        style={{ width: `${size}px`, height: `${size}px`, borderWidth: `${border}px` }}
      />
      {label ? (
        <div className="muted" style={{ marginTop: '10px' }}>{label}</div>
      ) : (
        <span className="sr-only">Loading</span>
      )}
    </div>
  );
}
